import { MotorStatusMdl } from "./MotorStatusMdl";

export class AddNewPolicyReqMdl {
    public RegNo: string;
    public PolicyType: string;
    public VDT: string;
    public IqamaNo: string;
    public SequenceNo: string;
    public CustomID: string;
    public CustomIssuenceDate: string;
    public OwnerIqamaNo: string;
    public isTransferOfShip: boolean;
    public PromoCode: string;
    public isProposalEdit: boolean;
    public productType: string;
    public editObj: ProposalEditMdl = new ProposalEditMdl();
    public st: MotorStatusMdl = new MotorStatusMdl();
    public isTPLActive: boolean;
    public isCOMPActive: boolean;
    public InsuredToken: string;
    public IqamaNoforDis: string;
    public VehicleModelYear: number;
    public IsRenewal: boolean;
    public PrvPolicyNo: string;

}

export class ProposalEditMdl {
    public ProposalNo: string;
    public JsonStr: string;
    public ProposalId: string;
}





// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Models/AddNewPolicyReqMdl.ts